import { useMemo, useCallback } from "react";
import {
  useGetMeQuery,
  useGetUserPermissionSlugsQuery,
} from "@/features/profile/infrastructure/api/ProfileApi";

export const usePermissions = () => {
  const { data: currentUser } = useGetMeQuery();
  const userId = currentUser?.id ?? "";

  const { data: slugs = [], isLoading } = useGetUserPermissionSlugsQuery(
    userId,
    { skip: !userId },
  );

  const slugSet = useMemo(() => new Set(slugs), [slugs]);
  const can = useCallback((slug: string): boolean => slugSet.has(slug), [slugSet]);

  return { can, isLoading };
};
